<script setup lang="ts">
  import MobileFieldCard from './MobileFieldCard.vue';
  import { useMobileSearchFlowContext } from '../../model/useMobileSearchFlow';

  interface MobileSearchFieldsProps {
    filled?: boolean;
  }

  withDefaults(defineProps<MobileSearchFieldsProps>(), {
    filled: false,
  });

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <div
    class="mobile-search-fields"
    data-testid="mobile-search-fields"
  >
    <MobileFieldCard
      v-if="flow.isVisibleDeparture.value"
      :label="flow.texts.labels.departure"
      :value="flow.departureValue.value"
      :placeholder="flow.texts.placeholders.departure"
      :filled="filled"
      testid="mobile-field-departure"
      @click="flow.editField('departure')"
    />

    <MobileFieldCard
      :label="flow.texts.labels.destination"
      :value="flow.destinationValue.value"
      :placeholder="flow.texts.placeholders.destination"
      :filled="filled"
      testid="mobile-field-destination"
      @click="flow.editField('destination')"
    />

    <MobileFieldCard
      :label="flow.texts.labels.date"
      :value="flow.dateValue.value"
      :placeholder="flow.texts.placeholders.date"
      :filled="filled"
      testid="mobile-field-date"
      @click="flow.editField('date')"
    />

    <MobileFieldCard
      :label="flow.texts.labels.nights"
      :value="flow.nightsValue.value"
      :filled="filled"
      testid="mobile-field-nights"
      @click="flow.editField('nights')"
    />

    <MobileFieldCard
      :label="flow.texts.labels.tourists"
      :value="flow.touristsValue.value"
      :filled="filled"
      testid="mobile-field-tourists"
      @click="flow.editField('tourists')"
    />
  </div>
</template>

<style scoped lang="scss">
  .mobile-search-fields {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
  }
</style>
